export default __webpack_public_path__ + "static/media/logo01.1a8fa281.png";